//公共模块
let allCommon = {
    verifySms: 'zyd-common/tools/sendSmsMessage',
    findList: "zyd-common/searchDoc",
    //字典管理
    dictTypeList: "zyd-common/dictType/queryAllByLimitDictType",
    dictQueryById: "zyd-common/dictType/queryByIdDictType",
    dictSave: "zyd-common/dictType/insertDictType",
    updateDictType: "zyd-common/dictType/updateDictType",
    dictDelete: "zyd-common/dictType/deleteDictType",
    getDictMap2: "zyd-common/dictType/getDictMap",
    dictGetDictValue: "zyd-common/dictValue/queryAllDictValue",
    dictQueryDictValue: "zyd-common/dictValue/queryByIdDictValue",
    dictSaveDictValue: "zyd-common/dictValue/insertDictValue",
    updateDictValue: "zyd-common/dictValue/updateDictValue",
    dictDeleteDictValue: "zyd-common/dictValue/deleteByIdDictValue",
    getversion: "zyd-common/getversion",
    // 上传设置
    businesssetting: 'zyd-common/businesssetting/list',
    businesssettingUpdateById: 'zyd-common/businesssetting/updateById',

    exportEsLog: 'zyd-common/exportEsLog',
    exportEsLogAll: 'zyd-common/exportEsLogAll',
    getByCode: 'zyd-common/businesssetting/getByCode',
    commonCache: 'zyd-common/tools/commonCache',

    //数字产权水印管理
    commonWatermarkList:'zyd-common/commonWatermark/list',
    commonWatermarkSave:'zyd-common/commonWatermark/save',
    commonWatermarkUpdateById:'zyd-common/commonWatermark/updateById',
    commonWatermarkGetById:'zyd-common/commonWatermark/getById/',
    commonWatermarkRemoveByIds:'zyd-common/commonWatermark/removeByIds',
    commonWatermarkHistoryList:'zyd-common/commonWatermarkHistory/list',
    commonWatermarkUsageRecordList:'zyd-common/commonWatermarkUsageRecord/list',

    //发送邮箱验证
    sysuserSendEmail:'zyd-common/tools/sendEmail',

    //消息
    commonMessageSelectMessageList:'zyd-common/commonMessage/selectMessageList',
    commonMessageBatchRead:'zyd-common/commonMessage/batchRead',
    commonMessageRemoveById:'zyd-common/commonMessage/removeById',
    commonMessageGetById:'zyd-common/commonMessage/getById/',

    //系统设置
    commonMessageSettingGetByMessageType:'zyd-common/commonMessageSetting/getByMessageType',
    commonMessageSettingUpdateByType:'zyd-common/commonMessageSetting/updateByType',

    //工作台
    commonBacklogList:'zyd-common/commonBacklog/list',

    //单个文件路径下载（打水印）
    fileDownload:'zyd-common/file/download',

    //查询所有业务模块
    selectBusinessTypeAll:'zyd-common/commonBacklog/selectBusinessTypeAll',
}

//用户、菜单、角色权限
let user = {
    loginOut: 'zyd-user/login/loginOut',
    basesysrole: 'zyd-user/basesysrole/list',
    queryRoleUserList: 'zyd-user/basesysrole/queryRoleUserList',
    basesysroleSave: 'zyd-user/basesysrole/save',
    basesysroleBatchRemove: 'zyd-user/basesysrole/batchRemove',
    getMenus: 'zyd-user/sysuser/getMenus',  // 用户权限查询接口
    getById: 'zyd-user/sysrolemenu/getById',  // 查询角色权限
    sysroleList: 'zyd-user/sysrole/list',  // 角色列表
    findAllMenu: 'zyd-user/sysnewmenu/findAllMenu',  // 角色列表
    findAllTenantMenu: 'zyd-user/moreTenant/findAllTenantMenu',
    sysRoleMetadataBasic: 'zyd-user/sysRoleMetadataBasic/getById',
    sysRoleMetadataBasicSave: 'zyd-user/sysRoleMetadataBasic/save',
    sysRoleMetadataDataPermission: 'zyd-user/sysRoleMetadataDataPermission/save',
    sysRoleMetadataDataPermissionGetById: 'zyd-user/sysRoleMetadataDataPermission/getById',
    sysnewmenuList: 'zyd-user/sysnewmenu/list',  // 查询菜单列表
    sysnewmenuRemoveById: 'zyd-user/sysnewmenu/removeById',  // 删除菜单
    sysnewmenuUpdateById: 'zyd-user/sysnewmenu/updateById',  // 修改菜单信息
    sysnewmenuSave: 'zyd-user/sysnewmenu/save',  // 新增菜单信息
    sysrolemenuSave: 'zyd-user/sysrolemenu/save',  // 角色授权保存
    removeById: 'zyd-user/sysuserrole/removeById',  // 移除角色用户
    sysroleGetById: 'zyd-user/sysrole/getById',  // 查询角色信息
    sysroleUpdateById: 'zyd-user/sysrole/updateById',  // 修改角色信息
    sysroleRemoveById: 'zyd-user/sysrole/removeById',  // 删除角色
    sysroleSave: 'zyd-user/sysrole/save',  // 新增角色
    sysuserQueryAllList: 'zyd-user/sysuser/queryUserList',  // 查询所有用户
    sysuserQueryRoleUserList: 'zyd-user/sysuserrole/queryRoleUserList',  // 查询非角色用户
    getByIdAllUser: 'zyd-user/sysuserrole/getByIdAllUser',  // 根据角色查询用户列表
    sysuserroleSave: 'zyd-user/sysuserrole/save',  // 批量关联角色用户
    login: "zyd-user/login/login", // 登录
    sysuserUpdateById: "zyd-user/sysuser/updateById", // 修改用户信息
    sysuserRemove: "zyd-user/sysuser/remove", // 删除用户信息
    sysuserSave: "zyd-user/sysuser/save", // 保存用户
    GetUserById: "zyd-user/sysuser/getById",
    getUserRoleInfo:'zyd-user/sysuser/getUserRoleInfo',
    removeLoginRestrictions: 'zyd-user/sysuser/removeLoginRestrictions/',
    updateSysUserPassword: 'zyd-user/sysuser/updateSysUserPassword',//修改密码
    getSysUserByName: 'zyd-user/sysuser/getSysUserByName',
    getSysTemporaryAuthorityRole: 'zyd-user/systemporaryauthority/getSysTemporaryAuthorityRole',
    getSysDepartment: 'zyd-user/sysdepartment/getSysDepartment',
    getEnabledSysDepartment: 'zyd-user/sysdepartment/getEnabledSysDepartment',
    departmentRemoveById: 'zyd-user/sysdepartment/removeById',
    departmentSave: 'zyd-user/sysdepartment/save',
    departmentUpdateById: 'zyd-user/sysdepartment/updateById',
    systemporaryauthorityList: 'zyd-user/systemporaryauthority/list',
    systemporaryauthoritySave: 'zyd-user/systemporaryauthority/save',
    systemporaryauthorityGetById: 'zyd-user/systemporaryauthority/getById',
    systemporaryauthorityUpdateById: 'zyd-user/systemporaryauthority/updateById',
    systemporaryauthorityRmoveById: 'zyd-user/systemporaryauthority/removeById',
    sysrolemenutempGetById: 'zyd-user/sysrolemenutemp/getById',
    sysrolemenutempSave: 'zyd-user/sysrolemenutemp/save',
    getSysDepartmentLibrary: 'zyd-user/sysdepartment/getSysDepartmentLibrary',
    exportUserList: 'zyd-user/sysuser/exportUserList',
    findByMenuResult: 'zyd-user/sysmenushortcutkeys/findByMenuResult',
    getSysMenuShortcutKeysByCreateBy: 'zyd-user/sysmenushortcutkeys/getSysMenuShortcutKeysByCreateBy',
    sysmenushortcutkeysSave: 'zyd-user/sysmenushortcutkeys/save',
    sysmenushortcutkeysRemoveById:'zyd-user/sysmenushortcutkeys/removeById/',
    getAllDepartment: 'zyd-user/sysdepartment/getAllDepartment',
    //参数管理
    configList: 'zyd-user/system/config/list',
    systemConfig: 'zyd-user/system/config',
    configClearCache: 'zyd-user/system/config/clearCache',
    getIsSysByUserId: 'zyd-user/sysrole/getIsSysByUserId',
    exportSysDepartment: 'zyd-user/sysdepartment/exportSysDepartment',
    // 系统设置
    getUserPasswordChangeReminder: 'zyd-user/system/config/getUserPasswordChangeReminder',
    sysMenuServiceSetupList:'zyd-user/sysMenuServiceSetup/list',
    sysMenuServiceSetupSave:'zyd-user/sysMenuServiceSetup/save',
    sysMenuBusinessSegmentList:'zyd-user/sysMenuBusinessSegment/list',
    sysMenuBusinessSegmentSave:'zyd-user/sysMenuBusinessSegment/save',
    sysMenuBusinessSegmentSetupList:'zyd-user/sysMenuBusinessSegmentSetup/list',
    //根据参数键名查询参数值
    configKey: 'zyd-user/system/config/configKey/',
    //查询所有角色
    sysroleQueryAll:'zyd-user/sysrole/queryAll',
    //认证管理
    sysAuthenticationQueryAuthenticationList:'zyd-user/SysAuthentication/queryAuthenticationList',
    sysAuthenticationExitByUserIds:'zyd-user/SysAuthentication/exitByUserIds',
    //授权管理
    sysUserAccreditList:'zyd-user/sysUserAccredit/list',
    sysUserAccreditSave:'zyd-user/sysUserAccredit/save',
    sysuserSelectAllUserAccount:'zyd-user/sysuser/selectAllUserAccount',
    sysUserAccreditGetById:'zyd-user/sysUserAccredit/getById/',
    sysUserAccreditUpdateById:'zyd-user/sysUserAccredit/updateById',
    sysUserAccreditRemoveByIds:'zyd-user/sysUserAccredit/removeByIds',
    updateAccreditStatusById:'zyd-user/sysUserAccredit/updateAccreditStatusById',
    //首页
    sysmenucommonfunctionList:'zyd-user/sysMenuCommonFunction/list',
    sysMenuCommonFunctionRemoveById:'zyd-user/sysMenuCommonFunction/removeById',
    sysMenuCommonFunctionFindByMenuResult:'zyd-user/sysMenuCommonFunction/findByMenuResult',
    sysMenuCommonFunctionSave:'zyd-user/sysMenuCommonFunction/save',

    queryUserListAllUsable:'zyd-user/sysuser/queryUserListAllUsable',
    getByType:'zyd-user/sysuserguidance/getByType',
    updateById:'zyd-user/sysuserguidance/updateById',
    //审核记录
    sysProcessInfoList:'zyd-user/sysProcessInfo/list',

    sysdepartmentGetDepartmentUserList:'zyd-user/sysdepartment/getDepartmentUserList',

    // 租户管理
    selectAll: 'zyd-user/tenantSetMeal/selectAll',
    phoneIsExist: 'zyd-user/systemporaryauthority/phoneIsExist',
    systemporaryauthorityRemoveById: 'zyd-user/systemporaryauthority/removeById',
    exportSysTemporaryAuthority: 'zyd-user/systemporaryauthority/exportSysTemporaryAuthority',
    loginNameIsExist: 'zyd-user/systemporaryauthority/loginNameIsExist',
    tenantSetMealList: 'zyd-user/tenantSetMeal/list',
    tenantSetMealRemoveById: 'zyd-user/tenantSetMeal/removeById',
    beforeRemoveById: 'zyd-user/tenantSetMeal/beforeRemoveById',
    tenantSetMealGetById: 'zyd-user/tenantSetMeal/getById',
    tenantSetMealSave: 'zyd-user/tenantSetMeal/save',
    getDepartmentAll: 'zyd-user/moreTenant/getDepartmentAll',
    queryTenantUserList: 'zyd-user/moreTenant/queryTenantUserList',
    deleteByUserId: 'zyd-user/moreTenant/deleteByUserId',
    deleteByTemporaryAuthorityId: 'zyd-user/moreTenant/deleteByTemporaryAuthorityId',
    selectAllTenant: 'zyd-user/systemporaryauthority/selectAllTenant',
    moreTenantSave: 'zyd-user/moreTenant/save',
    moreTenantGetById: 'zyd-user/moreTenant/getById',
    getByUserId: 'zyd-user/moreTenant/getByUserId',
    switchTenants: 'zyd-user/moreTenant/switchTenants',
    moreTenantUpdateById: 'zyd-user/moreTenant/updateById',
    tenantProductConfigurationInfo: 'zyd-user/tenantProductConfigurationInfo/getById',
}

// 元数据管理
let metadata = {
    selectTree: 'zyd-metadata/metadatabasic/selectTree',
    selectBasicRangTree: 'zyd-metadata/metadatabasic/selectBasicRangTree',
    selectAllDimension: 'zyd-metadata/metadatabasic/selectAllDimension',
    selectMetadataBasic: 'zyd-metadata/metadatabasic/selectMetadataBasic',
    selectAllMetadataBasicAssembly: 'zyd-metadata/metadatabasicassembly/selectAllMetadataBasicAssembly',
    save: 'zyd-metadata/metadatabasic/save',
    updateById: 'zyd-metadata/metadatabasic/updateById',
    getById: 'zyd-metadata/metadatabasic/getById',
    removeById: 'zyd-metadata/metadatabasic/removeById',
    selectMetadataBasicByAssembly: 'zyd-metadata/metadatabasic/selectMetadataBasicByAssembly',
    metadatarangeSave: 'zyd-metadata/metadatarange/save',
    selectMetadataBasicDataList: 'zyd-metadata/metadatabasicdata/selectMetadataBasicDataList',
    metadatabasicdataSave: 'zyd-metadata/metadatabasicdata/save',
    metadatabasicdataUpdateById: 'zyd-metadata/metadatabasicdata/updateById',
    metadatabasicdataGetById: 'zyd-metadata/metadatabasicdata/getById',
    batchDeleteMetadataBasicData: 'zyd-metadata/metadatabasicdata/batchDeleteMetadataBasicData',
    selectByBasicDataId: 'zyd-metadata/metadataBasicDataDetail/selectByBasicDataId',
    selectBasicNotInBasicDataId: 'zyd-metadata/metadatabasic/selectBasicNotInBasicDataId',
    associationMetadataBasicDataDetail: 'zyd-metadata/metadataBasicDataDetail/associationMetadataBasicDataDetail',
    metadataBasicDataDetailGetById: 'zyd-metadata/metadataBasicDataDetail/getById',
    metadataBasicDataDetailUpdateById: 'zyd-metadata/metadataBasicDataDetail/updateById',
    excludeAssociationBasicDataId: 'zyd-metadata/metadataBasicDataDetail/excludeAssociationBasicDataId',
    selectTreeNotInBasicDataId: 'zyd-metadata/metadatabasic/selectTreeNotInBasicDataId',
    batchAssociateMetadataBasicData: 'zyd-metadata/metadataBasicDataDetail/batchAssociateMetadataBasicData',
    batchDeleteMetadataBasicDataDetail: 'zyd-metadata/metadataBasicDataDetail/batchDeleteMetadataBasicDataDetail',
    selectMetadataBasicDataRangeRuleList: 'zyd-metadata/metadatabasicdatarangerule/selectMetadataBasicDataRangeRuleList',
    rangeRuleSave: 'zyd-metadata/metadatabasicdatarangerule/save',
    selectRangsByBasicDataId: 'zyd-metadata/metadataBasicDataDetail/selectRangsByBasicDataId',
    selectAllByBasicDataId: 'zyd-metadata/metadataBasicDataDetail/selectAllByBasicDataId',
    rangeRuleRemoveById: 'zyd-metadata/metadatabasicdatarangerule/removeById',
    selectMetadataBasicDataShowRuleList: 'zyd-metadata/metadatabasicdatashowrule/selectMetadataBasicDataShowRuleList',
    showRuleSave: 'zyd-metadata/metadatabasicdatashowrule/save',
    showRuleSaveRemoveById: 'zyd-metadata/metadatabasicdatashowrule/removeById',
    getByBasicDataDetailId: 'zyd-metadata/metadatabasicdatarule/getByBasicDataDetailId',
    metadatabasicdataruleSave: 'zyd-metadata/metadatabasicdatarule/save',
    selectFilesByBasicDataId: 'zyd-metadata/metadataBasicDataDetail/selectFilesByBasicDataId',
    selectTreeMetadataBasicDataById: 'zyd-metadata/metadatabasicdata/selectTreeMetadataBasicDataById',
    selectMetadataBasicDataRangeRuleModel: 'zyd-metadata/metadatabasicdatarangerule/selectMetadataBasicDataRangeRuleModel',
    selectBasicDataTable: 'zyd-metadata/metadatabasicdata/selectBasicDataTable',
    metadatafonctionsSave: 'zyd-metadata/metadatafonctions/save',
    metadatafonctionsList: 'zyd-metadata/metadatafonctions/list',
    metadatafonctionsRemoveById: 'zyd-metadata/metadatafonctions/removeById',
    metadatafonctionsmodelList: 'zyd-metadata/metadatafonctionsmodel/list',
    metadatafonctionsmodelSave: 'zyd-metadata/metadatafonctionsmodel/save',
    metadatafonctionsmodelUpdateById: 'zyd-metadata/metadatafonctionsmodel/updateById',
    deleteBatchIds: 'zyd-metadata/metadatafonctionsmodel/deleteBatchIds',
    selectAll: 'zyd-metadata/metadatafonctions/selectAll',
    metadatafonctionsmodelGetById: 'zyd-metadata/metadatafonctionsmodel/getById',
    getChangeById: 'zyd-metadata/metadatafonctionsmodel/getChangeById',
    queryUnionBasicDataDetailsByConfigId: 'zyd-metadata/metadataBasicDataDetail/queryUnionBasicDataDetailsByConfigId',
    copyAndSaveMetadataFonctionsModel: 'zyd-metadata/metadatafonctionsmodel/copyAndSaveMetadataFonctionsModel',
    getByName: 'zyd-metadata/metadatafonctionsmodel/getByName',
    metadatatableconfigList: 'zyd-metadata/metadatatableconfig/list',
    metadatatableconfigSave: 'zyd-metadata/metadatatableconfig/save',
    metadatatableconfigUpdateById: 'zyd-metadata/metadatatableconfig/updateById',
    metadatafonctionsmodelSelectAll: 'zyd-metadata/metadatafonctionsmodel/selectAll',
    selectMetadataBasicDataCleanList: 'zyd-metadata/metadatabasicdata/selectMetadataBasicDataCleanList',
    getTableAndWhere: 'zyd-metadata/metadataBasicDataDetail/getTableAndWhere',
    selectModelAndBasicData: 'zyd-metadata/metadatatableconfig/selectModelAndBasicData',
    metadatatableconfigDeleteBatchIds: 'zyd-metadata/metadatatableconfig/deleteBatchIds',
    metadatatableconfigGetById: 'zyd-metadata/metadatatableconfig/getById',
    queryUnionBasicDataDetailsByBasicDataIds: 'zyd-metadata/metadatabasic/queryUnionBasicDataDetailsByBasicDataIds',
    copyMetadataTableConfig: 'zyd-metadata/metadatatableconfig/copyMetadataTableConfig',
    selectMetadataTableConfigByTableName: 'zyd-metadata/metadatatableconfig/selectMetadataTableConfigByTableName',
    saveMetadataData: 'zyd-metadata/metadatadata/saveMetadataData',
    queryElasticsearchTemplatePage: 'zyd-metadata/metadatadata/queryElasticsearchTemplatePage',
    queryElasticsearchTemplatePageHome: 'zyd-metadata/metadatadata/queryElasticsearchTemplatePageHome',
    metadatadataGetById: 'zyd-metadata/metadatadata/getById',
    checkMetadataTableConfigPage: 'zyd-metadata/metadatatableconfigpage/checkMetadataTableConfigPage',
    batchDelete: 'zyd-metadata/metadatadata/batchDelete',
    batchUpdateDataByFonctionsModel: 'zyd-metadata/metadatadata/batchUpdateDataByFonctionsModel',
    delist: 'zyd-metadata/metadatadata/delist',
    checkConfigDataExistence: 'zyd-metadata/metadatatableconfig/checkConfigDataExistence',
    groupByTemplate: 'zyd-metadata/metadatadata/groupByTemplate',
    metadataDataPageViewList:'zyd-metadata/metadataDataPageView/list',
    // 模型核验
    consistencycheck: 'zyd-metadata/metadatabasicdatacheck/consistencycheck',
    codomaincheck: 'zyd-metadata/metadatabasicdatacheck/codomaincheck',
    currentDimensionalityAtomNum: 'zyd-metadata/metadatabasicdatacheck/currentDimensionalityAtomNum',
    otherDimensionalityAtomNum: 'zyd-metadata/metadatabasicdatacheck/otherDimensionalityAtomNum',
    compareResult: 'zyd-metadata/metadatabasicdatacheck/compareResult',
    alikeData: 'zyd-metadata/metadatabasicdatacheck/alikeData',
    imparityData: 'zyd-metadata/metadatabasicdatacheck/imparityData',
    alikeDataDetail: 'zyd-metadata/metadatabasicdatacheck/alikeDataDetail',
    metadatabasicdatadetailedition: 'zyd-metadata/metadatabasicdatadetailedition/list',
    metadatachangerecordList: 'zyd-metadata/metadatachangerecord/list',
    codomainCheckExport: 'zyd-metadata/metadatabasicdatacheck/codomainCheckExport',
    consistencycheckExport: 'zyd-metadata/metadatabasicdatacheck/consistencycheckExport',
    // 导入导出
    exportFieldList: 'zyd-metadata/metadatadataoperate/exportFieldList',
    batchExport: 'zyd-metadata/metadatadataoperate/batchExport',
    exportModelDownload: 'zyd-metadata/metadatadataoperate/exportModelDownload',
    excelImport: 'zyd-metadata/metadatadataoperate/excelImport',
    cacheKeyList: 'zyd-metadata/metadatadataoperate/cacheKeyList',
    saveExportData: 'zyd-metadata/metadatadataoperate/saveExportData',
    listExport: 'zyd-metadata/metadatachangerecord/listExport',
    metadatabasicdatadetaileditionExport: 'zyd-metadata/metadatabasicdatadetailedition/export',
    modeExport: 'zyd-metadata/businessmetadatabasicimport/modeExport',
    databasicExcelImport: 'zyd-metadata/businessmetadatabasicimport/excelImport',
    databasicList: 'zyd-metadata/businessmetadatabasicimport/list',
    databasicSave: 'zyd-metadata/businessmetadatabasicimport/save',
    allList: 'zyd-metadata/businessmodeexport/allList',
    businessExport: 'zyd-metadata/businessmodeexport/export',
    businessinit: 'zyd-metadata/businessmodeexport/init',
    updateDelFlagById: 'zyd-metadata/businessmodeexport/updateDelFlagById',
    findModeNumByUserId: 'zyd-metadata/businessmodeexport/findModeNumByUserId',
    selectInfo: 'zyd-metadata/businessmodeexport/selectInfo',
    updateSort: 'zyd-metadata/businessmodeexport/updateSort',
    infoAdd: 'zyd-metadata/businessmodeexport/infoAdd',
    infoUpdateSave: 'zyd-metadata/businessmodeexport/infoUpdateSave',
    ItemBatchExport: 'zyd-metadata/metadatadataoperate/ItemBatchExport',
    metadataBasicDataDetailExport: 'zyd-metadata/metadataBasicDataDetail/export',
    downloadFile: 'zyd-metadata/metadatadataoperate/downloadFile',
    downloadItemFile: 'zyd-metadata/metadatadataoperate/downloadItemFile',
    // 数据匹配
    matchPaths: 'zyd-metadata/metadatadatamatch/matchPaths',
    matchFieldList: 'zyd-metadata/metadatadatamatch/matchFieldList',
    startMatch: 'zyd-metadata/metadatadatamatch/startMatch',
    unMatchList: 'zyd-metadata/metadatadatamatch/unMatchList',
    unMatchListExport: 'zyd-metadata/metadatadatamatch/unMatchListExport',
    previewList: 'zyd-metadata/metadatadatamatch/previewList',
    execDataMatch: 'zyd-metadata/metadatadatamatch/execDataMatch',
    dataReorganizeFieldList: 'zyd-metadata/metadatadataoperate/dataReorganizeFieldList',
    dataReorganize: 'zyd-metadata/metadatadataoperate/dataReorganize',
    // 回收站
    selectMetadataRangesByBasicId: 'zyd-metadata/metadatarange/selectMetadataRangesByBasicId',
    selectRecycleMetadataDataList: 'zyd-metadata/metadatadata/selectRecycleMetadataDataList',
    selectMetadataDataDelLocal: 'zyd-metadata/metadatadata/selectMetadataDataDelLocal',
    selectMetadataDataDelBy: 'zyd-metadata/metadatadata/selectMetadataDataDelBy',
    cacheTableList: 'zyd-metadata/metadatatableconfig/cacheTableList',
    restoreData: 'zyd-metadata/metadatadata/restoreData',
    realDeleteData: 'zyd-metadata/metadatadata/realDeleteData',
    //脱敏处理
    releasesDesensitizationList:'zyd-metadata/releasesDesensitization/list',
    releasesDesensitizationSave:'zyd-metadata/releasesDesensitization/save',
    releasesDesensitizationGetById:'zyd-metadata/releasesDesensitization/getById/',
    releasesDesensitizationUpdateById:'zyd-metadata/releasesDesensitization/updateById',
    releasesDesensitizationRemoveByIds:'zyd-metadata/releasesDesensitization/removeByIds',
    releasesDesensitizationSelectAll:'zyd-metadata/releasesDesensitization/selectAll',
    metadataBasicDataDetailGetDesensitized:'zyd-metadata/metadataBasicDataDetail/getDesensitized',
    metadataSetDesensitizationBatchSave:'zyd-metadata/metadataSetDesensitization/batchSave',
    getByResourceId:'zyd-metadata/metadataSetDesensitization/getByResourceId',

    metadatadataQueryMetadataDataKeyWord:'zyd-metadata/metadatadata/queryMetadataDataKeyWord',
    //资源发布
    metadataPublishSave:'zyd-metadata/metadataPublish/save',
    metadatabasicSelectBasicSys:'zyd-metadata/metadatabasic/selectBasicSys',
    getMetadataBasicDataNamesById:'zyd-metadata/metadatabasicdata/getMetadataBasicDataNamesById',
    //紧急处理
    selectAllMetadataBasicByBasicCode:'zyd-metadata/metadataEmergencyTreatment/selectAllMetadataBasicByBasicCode',
    hiddenCommit:'zyd-metadata/metadataEmergencyTreatment/hiddenCommit',
    batchUpdateDataByFonctionsState:'zyd-metadata/metadatadata/batchUpdateDataByFonctionsState',
    metadatadataDelist:'zyd-metadata/metadatadata/delist',
    //检索结果页、首页
    selectTemplateByStatus:'zyd-metadata/metadatadata/selectTemplateByStatus',
    selectMetadataDataIndex:'zyd-metadata/metadataDataIndex/selectMetadataDataIndex',
    metadataDataIndexQuantity:'zyd-metadata/metadataDataIndex/metadataDataIndexQuantity',
    addMetadataDataHistoryIndex:'zyd-metadata/metadataDataIndex/addMetadataDataHistoryIndex',
    selectMetadataDataHistoryIndex:'zyd-metadata/metadataDataIndex/selectMetadataDataHistoryIndex',
    delMetadataDataHistoryIndex:'zyd-metadata/metadataDataIndex/delMetadataDataHistoryIndex',
    //我的收藏
    academicMyCollectionList:'zyd-metadata/academicMyCollection/list',
    academicMyCollectionSave:'zyd-metadata/academicMyCollection/save',
    academicMyCollectionUpdateByIds:'zyd-metadata/academicMyCollection/updateByIds',
    metadataDataPageView:'zyd-metadata/metadataDataPageView/save',

    selectAllUser:'zyd-metadata/releasesDesensitization/selectAllUser',
    batchShowByMetadataId:'zyd-metadata/metadataPublish/batchShowByMetadataId',
    batchUpdateDataBySequence:'zyd-metadata/metadatadata/batchUpdateDataBySequence',
    // 关联业务模板
    queryMetadataBasicDataAssociationList:'zyd-metadata/metadatabasicdataassociation/queryMetadataBasicDataAssociationList',
    metadatabasicdataassociationSave:'zyd-metadata/metadatabasicdataassociation/save',
    // 典藏出入库
    batchReception: 'zyd-metadata/metadataCollection/batchReception',
    editTemp: 'zyd-metadata/metadataCollection/editTemp',
    selectAllStoreroom: 'zyd-metadata/metadataCollection/selectAllStoreroom',
    selectAllContainer: 'zyd-metadata/metadataCollection/selectAllContainer',
    metadataCollectionSubmit: 'zyd-metadata/metadataCollection/submit',
    batchOutbound: 'zyd-metadata/metadataCollection/batchOutbound',
    editOutboundTemp: 'zyd-metadata/metadataCollection/editOutboundTemp',
    submitOutbound: 'zyd-metadata/metadataCollection/submitOutbound',
    batchRecycle: 'zyd-metadata/metadataCollection/batchRecycle',
    editRecycleTemp: 'zyd-metadata/metadataCollection/editRecycleTemp',
    submitRecycle: 'zyd-metadata/metadataCollection/submitRecycle',
    batchWithdrawing: 'zyd-metadata/metadataCollection/batchWithdrawing',
    editWithdrawingTemp: 'zyd-metadata/metadataCollection/editWithdrawingTemp',
    submitWithdrawing: 'zyd-metadata/metadataCollection/submitWithdrawing',
    moveLibraryAcceptance: 'zyd-metadata/metadataCollection/moveLibraryAcceptance',
    acceptance: 'zyd-metadata/metadataCollection/acceptance',
}

//学术研究子系统
let academic = {
    thematicList: 'zyd-academic/thematic/list',
    thematicSave: 'zyd-academic/thematic/save',
    thematicGetById: 'zyd-academic/thematic/getById/',
    thematicUpdateById: 'zyd-academic/thematic/updateById',
    thematicRemoveById: 'zyd-academic/thematic/removeById',
    categoricalindexList: 'zyd-academic/categoricalindex/list',
    categoricalindexSave: 'zyd-academic/categoricalindex/save',
    webresourceList: 'zyd-academic/webresource/list',
    webresourceSave: 'zyd-academic/webresource/save',
    webresourceGetById: 'zyd-academic/webresource/getById/',
    webresourceUpdateById: 'zyd-academic/webresource/updateById',
    webresourceRemoveById: 'zyd-academic/webresource/removeById',
    academicresourcesList: 'zyd-academic/academicresources/list',
    academicresourcesSave: 'zyd-academic/academicresources/save',
    academicresourcesGetById: 'zyd-academic/academicresources/getById/',
    academicresourcesUpdateById: 'zyd-academic/academicresources/updateById',
    academicresourcesRemoveById: 'zyd-academic/academicresources/removeById',
    categoricalindexGetById: 'zyd-academic/categoricalindex/getById/',
    categoricalindexUpdateById: 'zyd-academic/categoricalindex/updateById',
    categoricalindexRemoveById: 'zyd-academic/categoricalindex/removeById',
    categoricalindexIndexList: 'zyd-academic/categoricalindex/indexList',
    groupingList: 'zyd-academic/grouping/list',
    groupingSave: 'zyd-academic/grouping/save',
    groupingUpdateById:'zyd-academic/grouping/updateById',
    groupingRemoveById: 'zyd-academic/grouping/removeById',
    resourceapplicationList: 'zyd-academic/resourceapplication/list',
    resourceapplicationGetById: 'zyd-academic/resourceapplication/getById/',
    resourceapplicationUpdateById: 'zyd-academic/resourceapplication/updateById',
    resourceapplicationSubmit: 'zyd-academic/resourceapplication/submit',
    resourceapplicationRemoveById: 'zyd-academic/resourceapplication/removeById',
    resourceapplicationAuditList: 'zyd-academic/resourceapplication/auditList',
    resourceapplicationApplicationUserList: 'zyd-academic/resourceapplication/applicationUserList',
    resourceapplicationAudit: 'zyd-academic/resourceapplication/audit',
    resourceapplicationAuditUserList: 'zyd-academic/resourceapplication/auditUserList',
    resourceapplicationApplicationList: 'zyd-academic/resourceapplication/applicationList',
    groupingGetById: 'zyd-academic/grouping/getById/',
    groupingExport: 'zyd-academic/grouping/export',
    knowledgenodeList: 'zyd-academic/knowledgenode/list',
    knowledgenodeSave: 'zyd-academic/knowledgenode/save',
    knowledgenodeGetById: 'zyd-academic/knowledgenode/getById/',
    knowledgenodeUpdateById: 'zyd-academic/knowledgenode/updateById',
    knowledgenodeRemoveById: 'zyd-academic/knowledgenode/removeById',
    knowledgenodeExport: 'zyd-academic/knowledgenode/export',
    knowledgenodeManageList: 'zyd-academic/knowledgenode/manageList',
    knowledgenodeExportCentre: 'zyd-academic/knowledgenode/exportCentre',
    knowledgegraphList: 'zyd-academic/knowledgegraph/list',
    knowledgegraphSave: 'zyd-academic/knowledgegraph/save',
    knowledgegraphUpdateById: 'zyd-academic/knowledgegraph/updateById',
    knowledgegraphGetById: 'zyd-academic/knowledgegraph/getById/',
    knowledgegraphRemoveById: 'zyd-academic/knowledgegraph/removeById',
    knowledgegraphExport: 'zyd-academic/knowledgegraph/export',
    knowledgegraphOpenList: 'zyd-academic/knowledgegraph/openList',
    knowledgegraphExportCentre: 'zyd-academic/knowledgegraph/exportCentre',
    knowledgegraphnodeGetById:'zyd-academic/knowledgegraphnode/getByKnowledgeId/',
    knowledgenodeKnowledgeGraphNodeList:'zyd-academic/knowledgenode/KnowledgeGraphNodeList',
    resourceapplicationExport:'zyd-academic/resourceapplication/export',
    groupingQueryList:'zyd-academic/grouping/queryList',
    relevancedataQueryRemoveGroupingList:'zyd-academic/relevancedata/queryRemoveGroupingList',
    knowledgegraphnodeSave:'zyd-academic/knowledgegraphnode/save',
    knowledgegraphnodeList:'zyd-academic/knowledgegraphnode/list',
    knowledgegraphnoeGetById:'zyd-academic/knowledgegraphnode/getById/',
    knowledgegraphnoeGetParentNameById:'zyd-academic/knowledgegraphnode/getParentNameById/',
    knowledgegraphnodeUpdateById:'zyd-academic/knowledgegraphnode/updateById',
    knowledgegraphnodeBatchSave:'zyd-academic/knowledgegraphnode/batchSave',
    knowledgegraphnodeBatchUpdate:'zyd-academic/knowledgegraphnode/batchUpdate',
    knowledgegraphnodeRemoveById:'zyd-academic/knowledgegraphnode/removeById',
    knowledgegraphnodeExport:'zyd-academic/knowledgegraphnode/export',
    knowledgegraphGetByIdGeneral:'zyd-academic/knowledgegraph/getByIdGeneral/',
    getBasicDataList:'zyd-academic/relevancedata/getBasicDataList',
    relevancedataList:'zyd-academic/relevancedata/list',
    relevancedataRemoveByI:'zyd-academic/relevancedata/removeByI',
    relevancedataExport:'zyd-academic/relevancedata/export',
    resourceapplicationSave:'zyd-academic/resourceapplication/save',
    resourceapplicationGetBasicDataList:'zyd-academic/resourceapplication/getBasicDataList',
    getResourceList:'zyd-academic/resourceapplication/getResourceList',
    resourceapplicationCancelById:'zyd-academic/resourceapplication/cancelById',
    knowledgenodeExportModel:'zyd-academic/knowledgenode/exportModel',
    knowledgenodeExcelImport:'zyd-academic/knowledgenode/excelImport',
    knowledgenodePreviewList:'zyd-academic/knowledgenode/previewList',
    knowledgenodeBatchSave:'zyd-academic/knowledgenode/batchSave',
    knowledgegraphExcelImport:'zyd-academic/knowledgegraph/excelImport',
    knowledgegraphPreviewList:'zyd-academic/knowledgegraph/previewList',
    knowledgegraphBatchSave:'zyd-academic/knowledgegraph/batchSave',
    knowledgegraphExportModel:'zyd-academic/knowledgegraph/exportModel',
    thematicQsueryRankingList:'zyd-academic/thematic/queryRankingList',
    thematicQueryTotal:'zyd-academic/thematic/queryTotal',
    categoricalindexQueryList:'zyd-academic/categoricalindex/queryList',
    //多源异构汇聚子系统-资源标注
    resourceslabelList: 'zyd-academic/resourceslabel/list',
    resourceslabelGetById:'zyd-academic/resourceslabel/getById/',
    resourceslabelUpdateById:'zyd-academic/resourceslabel/updateById',
    resourceslabelSendBack:'zyd-academic/resourceslabel/sendBack',
    resourceslabelSubmit:'zyd-academic/resourceslabel/submit',
    resourceslabelRemoveById:'zyd-academic/resourceslabel/removeById',
    resourceslabelExport:'zyd-academic/resourceslabel/export',
    resourceslabelAuditList:'zyd-academic/resourceslabel/auditList',
    resourceslabelAudit:'zyd-academic/resourceslabel/audit',
    resourceslabelLabelList:'zyd-academic/resourceslabel/labelList',
    resourceslabelResourcesLabelUserList:'zyd-academic/resourceslabel/resourcesLabelUserList',
    resourceslabelExportLabelData:'zyd-academic/resourceslabel/exportLabelData',
    resourceslabelQueryLis:'zyd-academic/resourceslabel/queryLis',
    resourceslabelBatchSave:'zyd-academic/resourceslabel/batchSave',
    resourceslabelQueryRemoveList:'zyd-academic/resourceslabel/queryRemoveList',
    resourceslabelRemoveByResourcesLabel:'zyd-academic/resourceslabel/removeByResourcesLabel',
    relevancedataQueryRemoveThematicList:'zyd-academic/relevancedata/queryRemoveThematicList',
    relevancedataRemoveByRelevanceData:'zyd-academic/relevancedata/removeByRelevanceData',
    thematicQueryList:'zyd-academic/thematic/queryList',
    relevancedataBatchSave:'zyd-academic/relevancedata/batchSave',
    getResourceIds:'zyd-academic/resourceapplication/getResourceIds',
    resourceapplicationAppend:'zyd-academic/resourceapplication/append',
    getApplicationOddList:'zyd-academic/resourceapplication/getApplicationOddList',
    //多源异构汇聚子系统-数据源设定
    connectionpoolList:'zyd-academic/connectionpool/list',
    connectionpoolSave:'zyd-academic/connectionpool/save',
    connectionpoolGetById:'zyd-academic/connectionpool/getById/',
    connectionpoolRemoveById:'zyd-academic/connectionpool/removeById',
    filesourceList:'zyd-academic/filesource/list',
    filesourceSave:'zyd-academic/filesource/save',
    filesourceUpdateById:'zyd-academic/filesource/updateById',
    filesourceGetById:'zyd-academic/filesource/getById/',
    filesourceRemoveById:'zyd-academic/filesource/removeById',
    interfacesourceList:'zyd-academic/interfacesource/list',
    interfacesourceSave:'zyd-academic/interfacesource/save',
    interfacesourceUpdateById:'zyd-academic/interfacesource/updateById',
    interfacesourceGetById:'zyd-academic/interfacesource/getById/',
    interfacesourceRemoveById:'zyd-academic/interfacesource/removeById',
    //资源监管子系统-质量检测方案管理
    qualityinspectionList:'zyd-academic/qualityinspection/list',
    qualityinspectionCreateByList:'zyd-academic/qualityinspection/createByList',
    qualityinspectionRemoveById:'zyd-academic/qualityinspection/removeById',
    qualityinspectionSave:'zyd-academic/qualityinspection/save',
    qualityinspectionUpdateById:'zyd-academic/qualityinspection/updateById',
    qualityinspectionGetById:'zyd-academic/qualityinspection/getById/',
    qualityinspectionreportList:'zyd-academic/qualityinspectionreport/list',
    qualityinspectionreportRemoveById:'zyd-academic/qualityinspectionreport/removeById',
    qualityinspectionQueryList:'zyd-academic/qualityinspection/queryList',
    qualityinspectionitemList:'zyd-academic/qualityinspectionitem/list',
    qualityinspectionitemListAll:'zyd-academic/qualityinspectionitem/listAll',
    qualityinspectionreportSave:'zyd-academic/qualityinspectionreport/save',
    resourcesIdQuality:'zyd-academic/qualityinspectionreport/resourcesIdQuality',
    downloadReportByCode:'zyd-academic/qualityinspectionreport/downloadReportByCode',
    downloadReportById:'zyd-academic/qualityinspectionreport/downloadReportById',
    downloadReport:'zyd-academic/qualityinspectionreport/downloadReport',
    // 标签
    resourceslabelSave:'zyd-academic/resourceslabel/save',
    resourceslabelPassSave:'zyd-academic/resourceslabel/passSave',
    getByResourcesId:'zyd-academic/resourceslabel/getByResourcesId',
    queryLabelLis:'zyd-academic/resourceslabel/queryLabelLis',
    //学术资源管理
    semanticcorpusList:'zyd-academic/semanticcorpus/list',
    semanticcorpusSave:'zyd-academic/semanticcorpus/save',
    semanticcorpusGetById:'zyd-academic/semanticcorpus/getById/',
    semanticcorpusUpdateById:'zyd-academic/semanticcorpus/updateById',
    semanticcorpusRemoveById:'zyd-academic/semanticcorpus/removeById/',
    semanticcorpusExport:'zyd-academic/semanticcorpus/export',
    semanticcorpusdataList:'zyd-academic/semanticcorpusdata/list',
    semanticcorpusdataSave:'zyd-academic/semanticcorpusdata/save',
    semanticcorpusdataUpdateById:'zyd-academic/semanticcorpusdata/updateById',
    semanticcorpusdataGetById:'zyd-academic/semanticcorpusdata/getById/',
    semanticcorpusdataRemoveById:'zyd-academic/semanticcorpusdata/removeById/',
    //知识模型管理
    knowledgemodelList:'zyd-academic/knowledgemodel/list',
    knowledgemodelSave:'zyd-academic/knowledgemodel/save',
    knowledgemodelGetById:'zyd-academic/knowledgemodel/getById/',
    knowledgemodelUpdateById:'zyd-academic/knowledgemodel/updateById',
    knowledgemodelUpdateBatchIds:'zyd-academic/knowledgemodel/updateBatchIds',
    knowledgemodelRemoveById:'zyd-academic/knowledgemodel/removeById',
    knowledgemodelnodeGetById:'zyd-academic/knowledgemodelnode/getById/',
    knowledgemodelnodeGetByKnowledgeModelId:'zyd-academic/knowledgemodelnode/getByKnowledgeModelId/',
    knowledgemodelShare:'zyd-academic/knowledgemodel/share',
    knowledgemodelnodeSave:'zyd-academic/knowledgemodelnode/save',
    knowledgemodelnodeList:'zyd-academic/knowledgemodelnode/list',
    knowledgemodelnodeUpdateById:'zyd-academic/knowledgemodelnode/updateById',
    knowledgemodelPublicList:'zyd-academic/knowledgemodel/publicList',
    knowledgemodelnodeBatchUpdate:'zyd-academic/knowledgemodelnode/batchUpdate',
    knowledgemodelnodeRemoveById:'zyd-academic/knowledgemodelnode/removeById',
    semanticcorpusQueryListAll:'zyd-academic/semanticcorpus/queryListAll',
    knowledgemodelnodeBatchSave:'zyd-academic/knowledgemodelnode/batchSave',
    semanticcorpusQueryList:'zyd-academic/semanticcorpus/queryList',
    knowledgemodelOneClickSave:'zyd-academic/knowledgemodel/oneClickSave',
    knowledgemodelQueryList:'zyd-academic/knowledgemodel/queryList',
    knowledgemodelQueryPublicList:'zyd-academic/knowledgemodel/queryPublicList',

}

//多源异构发布子系统
let dyygRelease = {
    releasesChannelList: 'zyd-releases/releasesChannel/list',
    releasesChannelSave: 'zyd-releases/releasesChannel/save',
    releasesChannelGetById: 'zyd-releases/releasesChannel/getById/',
    releasesChannelUpdateById: 'zyd-releases/releasesChannel/updateById',
    releasesChannelSelectAll: 'zyd-releases/releasesChannel/selectAll',
    releasesColumnManagementSave: 'zyd-releases/releasesColumnManagement/save',
    releasesColumnManagementList: 'zyd-releases/releasesColumnManagement/list',
    releasesColumnManagementGetById: 'zyd-releases/releasesColumnManagement/getById/',
    releasesColumnManagementUpdateById: 'zyd-releases/releasesColumnManagement/updateById',
    releasesRecommendationSave: 'zyd-releases/releasesRecommendation/save',
    releasesRecommendationList: 'zyd-releases/releasesRecommendation/list',
    releasesRecommendationGetById: 'zyd-releases/releasesRecommendation/getById/',
    releasesRecommendationUpdateById: 'zyd-releases/releasesRecommendation/updateById',
    releasesColumnManagementRemoveByIds: 'zyd-releases/releasesColumnManagement/removeByIds',
    releasesChannelRemoveByIds: 'zyd-releases/releasesChannel/removeByIds',
    releasesRecommendationRemoveByIds: 'zyd-releases/releasesRecommendation/removeByIds',
    //流程管理
    releasesFlowList: 'zyd-releases/releasesFlow/list',
    releasesFlowSave: 'zyd-releases/releasesFlow/save',
    releasesFlowGetById: 'zyd-releases/releasesFlow/getById/',
    releasesFlowUpdateById: 'zyd-releases/releasesFlow/updateById',
    releasesFlowEnableOrDisable:'zyd-releases/releasesFlow/enableOrDisable',
    releasesFlowRemoveByIds: 'zyd-releases/releasesFlow/removeByIds',
    getByChannelId:'zyd-releases/releasesColumnManagement/getByChannelId/',
    getByChannelIds:'zyd-releases/releasesColumnManagement/getByChannelIds',
}

//典藏接口
let collection = {
    collectionoutwarehouseList:'zyd-collection/collectionoutwarehouse/list',
    saveOrUpdate:'zyd-collection/collectionoutwarehouse/saveOrUpdate',
    outWarehouseApplyUser:'zyd-collection/collectionoutwarehouse/outWarehouseApplyUser',
    collectionoutwarehouseBatchSubmit:'zyd-collection/collectionoutwarehouse/batchSubmit',
    collectionoutwarehouseBatchExport:'zyd-collection/collectionoutwarehouse/batchExport',
    collectionoutwarehouseRemoveById:'zyd-collection/collectionoutwarehouse/removeById',
    collectionoutwarehouseTabCount:'zyd-collection/collectionoutwarehouse/tabCount',
    getOutWarehouseById:'zyd-collection/collectionoutwarehouse/getOutWarehouseById/',
    outWarehouseSelect:'zyd-collection/collectionoutwarehouse/outWarehouseSelect',
    confirmOutboundInfo:'zyd-collection/collectionoutwarehouse/confirmOutboundInfo',
    confirmOutbound:'zyd-collection/collectionoutwarehouse/confirmOutbound',
    revdTabCount:'zyd-collection/collectionoutwarehouse/revdTabCount',
    collectionoutwarehouseRevdlist:'zyd-collection/collectionoutwarehouse/revdlist',
    batchSuccess:'zyd-collection/collectionoutwarehouse/batchSuccess',
    batchReject:'zyd-collection/collectionoutwarehouse/batchReject',
    outWarehouseRecodePage:'zyd-collection/collectionoutwarehouseitem/outWarehouseRecodePage',
    outWarehouseStandingBookPage:'zyd-collection/collectionoutwarehouseitem/outWarehouseStandingBookPage',
    outWarehouseRecodeTabCount:'zyd-collection/collectionoutwarehouseitem/outWarehouseRecodeTabCount',
    outWarehouseRecodeBatchExport:'zyd-collection/collectionoutwarehouseitem/outWarehouseRecodeBatchExport',
    outWarehouseStandingBookBatchExport:'zyd-collection/collectionoutwarehouseitem/outWarehouseStandingBookBatchExport',
    getOutWarehouseCollectionInfo:'zyd-collection/collectionoutwarehouseitem/getOutWarehouseCollectionInfo/',
    inWarehouseInfoQueryPage:'zyd-collection/collectioninwarehouse/inWarehouseInfoQueryPage',
    inWarehouseInfoUserNameQueryPage: 'zyd-collection/collectioninwarehouse/inWarehouseInfoUserNameQueryPage',
    tabCountInWarehouse:'zyd-collection/collectioninwarehouse/tabCountInWarehouse',
    collectioninwarehouseSaveOrUpdate:'zyd-collection/collectioninwarehouse/saveOrUpdate',
    collectioninwarehouseBatchSubmit:'zyd-collection/collectioninwarehouse/batchSubmit',
    inWarehouseInfoQueryPageExport:'zyd-collection/collectioninwarehouse/inWarehouseInfoQueryPageExport',
    getInWarehouseById:'zyd-collection/collectioninwarehouse/getInWarehouseById/',
    collectioninwarehouseRemoveById:'zyd-collection/collectioninwarehouse/removeById',
    receiveInfo:'zyd-collection/collectioninwarehouse/receiveInfo',
    collectionwarehouseAllWarehouse:'zyd-collection/collectionwarehouse/allWarehouse',
    getByWarehouseId:'zyd-collection/collectionshelf/getByWarehouseId/',
    collectioninwarehouseReceive:'zyd-collection/collectioninwarehouse/receive',
    revdTabCountInWarehouse:'zyd-collection/collectioninwarehouse/revdTabCountInWarehouse',
    collectioninwarehouseBatchSuccess:'zyd-collection/collectioninwarehouse/batchSuccess',
    collectioninwarehouseBatchReject:'zyd-collection/collectioninwarehouse/batchReject',
    revdlistApplicantName:'zyd-collection/collectioninwarehouse/revdlistApplicantName',
    collectioninwarehouseRevdlist:'zyd-collection/collectioninwarehouse/revdlist',
    tabCountInWarehouseInfo:'zyd-collection/collectioninwarehouse/tabCountInWarehouseInfo',
    inWarehouseLedgerQueryPage:'zyd-collection/collectioninwarehouse/inWarehouseLedgerQueryPage',
    inWarehouseLedgerInfoQueryPage:'zyd-collection/collectioninwarehouse/inWarehouseLedgerInfoQueryPage',
    getInWarehouseCollectionInfo:'zyd-collection/collectioninwarehouseitem/getInWarehouseCollectionInfo/',
    inWarehouseLedgerInfoQueryPageExport:'zyd-collection/collectioninwarehouse/inWarehouseLedgerInfoQueryPageExport',
}

// 课题
let topic ={
    selectMetadataBasicDataPermissionList: 'zyd-topic/metadatabasicdata/selectMetadataBasicDataPermissionList',
    selectMetadataBasicPermission: 'zyd-topic/metadatabasic/selectMetadataBasicPermission',
    selectAllAtom: 'zyd-topic/metadatabasic/selectAllAtom',
}

export default {
    topic,
    allCommon,
    user,
    metadata,
    academic,
    dyygRelease,
    collection
}
